<script>
  import currentUser from '../stores/auth';
  import {Link, navigate} from "svelte-routing";

  async function logOut() {
    await currentUser.logout();

    navigate('/');
  }
</script>

<header>
  <nav>
    <Link to="/">
      <span class="brand">
        <img class="logo" src="/assets/images/bspl-logo-pixelated.png"/>
        <div>BS Poland</div>
      </span>
    </Link>

    <div class="right">
      <Link to="/projects">All projects</Link>
      {#if $currentUser}
        <Link to="/admin/home">Me</Link>
        <a on:click={logOut}>Logout</a>
      {:else}
        <Link to="/login">Login</Link>
      {/if}
    </div>
  </nav>
</header>

<style>
    header nav {
        display: flex;
        align-items: center;
    }

    header nav > * {
        flex-grow: 0;
        flex-shrink: 1;
    }

    .brand {
        font-size: 14px;
        margin-right: 1rem;

        display: inline-flex;
        align-items: center;
    }

    .logo {
        width: 40px;
        height: 40px;
        margin-right: .5rem;
    }

    .right {
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    header nav .right :global(> *) {
        margin-right: 1rem;
    }

    header nav .right :global(> *:last-child) {
        margin-right: 0;
    }

    header nav :global(a) {
        text-decoration: none;
    }

    header nav :global(a:hover) {
        text-decoration: underline;
    }
</style>